<h2 mat-dialog-title tabindex="0" class="narrow" data-test-id="create-verfuegung-dialog-title">
	Verfügung erstellen mit folgenden Aufgaben
</h2>

<form [formGroup]="form">
	<mat-dialog-content>
		<div class="wizard">
			@if (valideAufgabenTypen.includes(aufgabenTypen.FINANZSANKTIONSLISTE)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.FINANZSANKTIONSLISTE, $event.checked)"
					data-test-id="finanzsanktionsliste-checkbox">
					Finanzsanktionsliste und SIS geprüft
				</mat-checkbox>
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.SCHIFFSZERTIFIKAT)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.SCHIFFSZERTIFIKAT, $event.checked)"
					data-test-id="verfuegung-zertifikat-checkbox">
					Zertifikat
				</mat-checkbox>
				@if (formService.schiffszertifikatGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-zertifikat-editor
							[aufgabenTyp]="aufgabenTypen.SCHIFFSZERTIFIKAT"
							data-test-id="verfuegung-aufgabe-zertifikat" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.SCHIFFSBRIEF)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.SCHIFFSBRIEF, $event.checked)"
					data-test-id="verfuegung-schiffsbrief-checkbox">
					Schiffsbrief
				</mat-checkbox>
				@if (formService.schiffsbriefGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-zertifikat-editor
							[aufgabenTyp]="aufgabenTypen.SCHIFFSBRIEF"
							data-test-id="verfuegung-aufgabe-schiffsbrief" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.ALTER_SCHIFFSBRIEF)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.ALTER_SCHIFFSBRIEF, $event.checked)"
					data-test-id="alter-schiffsbrief-checkbox">
					Alten Schiffsbrief unbrauchbar machen und zur Akte nehmen
				</mat-checkbox>
				@if (formService.alterSchiffsbriefGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-with-notiz-editor
							[aufgabenTyp]="aufgabenTypen.ALTER_SCHIFFSBRIEF"
							data-test-id="alter-schiffsbrief" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.ALTES_ZERTIFIKAT)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.ALTES_ZERTIFIKAT, $event.checked)"
					data-test-id="altes-zertifikat-checkbox">
					Altes Zertifikat
					<span>{{ aufgabeTypStaticTaetigkeitLabel[aufgabenTypen.ALTES_ZERTIFIKAT] }}</span>
				</mat-checkbox>
				@if (formService.altesZertifikatGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-with-notiz-editor
							[aufgabenTyp]="aufgabenTypen.ALTES_ZERTIFIKAT"
							data-test-id="altes-zertifikat" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.ZERTIFIKATSAUSZUG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.ZERTIFIKATSAUSZUG, $event.checked)"
					data-test-id="verfuegung-zertifikatsauszug-checkbox">
					Zertifikatsauszug
				</mat-checkbox>
				@if (formService.zertifikatsauszugGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-zertifikatsauszug-editor
							data-test-id="verfuegung-zertifikatsauszug" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.ABSCHRIFT_ZERTIFIKATSAUSZUG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.ABSCHRIFT_ZERTIFIKATSAUSZUG, $event.checked)"
					data-test-id="verfuegung-abschrift-zertifikatsauszug-checkbox">
					Begl. Abschrift
					<span>des Zertifikatsauszugs fertigen</span>
				</mat-checkbox>
				@if (formService.abschriftZertifikatsauszugGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-versand-editor
							[aufgabenTyp]="aufgabenTypen.ABSCHRIFT_ZERTIFIKATSAUSZUG"
							class="push-top-taetigkeit"
							data-test-id="verfuegung-abschrift-zertifikatsauszug" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.ALTER_AUSZUG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.ALTER_AUSZUG, $event.checked)"
					data-test-id="alter-auszug-checkbox">
					Alten Auszug
					<span>{{ aufgabeTypStaticTaetigkeitLabel[aufgabenTypen.ALTER_AUSZUG] }}</span>
				</mat-checkbox>
				@if (formService.alterAuszugGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-with-notiz-editor
							[aufgabenTyp]="aufgabenTypen.ALTER_AUSZUG"
							data-test-id="alter-auszug" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.EIGENTUEMERBESCHEINIGUNG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleBescheinigungGroup($event.checked)"
					data-test-id="bescheinigung-fertigen-checkbox">
					Bescheinigung fertigen
				</mat-checkbox>
				@if (formService.bescheinigungGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-bescheinigung-editor />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.REGISTERABSCHRIFT)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.REGISTERABSCHRIFT, $event.checked)"
					data-test-id="verfuegung-registerabschrift-checkbox">
					Registerabschrift
					<span>fertigen</span>
				</mat-checkbox>
				@if (formService.registerabschriftGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-abschrift-editor data-test-id="verfuegung-abschrift" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.EINTRAGUNGSMITTEILUNG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.EINTRAGUNGSMITTEILUNG, $event.checked)"
					data-test-id="verfuegung-eintragungsmitteilung-checkbox">
					Eintragungsmitteilung
					<span>fertigen</span>
				</mat-checkbox>
				@if (formService.eintragungsmitteilungGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-mitteilung-editor
							class="mitteilung-sub"
							[register]="register"
							data-test-id="verfuegung-eintragungsmitteilung" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.MESSBRIEF)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.MESSBRIEF, $event.checked)"
					data-test-id="verfuegung-messbrief-checkbox">
					Messbrief
				</mat-checkbox>
				@if (formService.messbriefGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-messbrief-editor
							[aufgabenTyp]="aufgabenTypen.MESSBRIEF"
							[register]="register"
							data-test-id="verfuegung-messbrief" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.VERMESSUNGSURKUNDE)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.VERMESSUNGSURKUNDE, $event.checked)"
					data-test-id="vermessungsurkunde-checkbox">
					Vermessungsurkunde
				</mat-checkbox>
				@if (formService.vermessungsurkundeGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-messbrief-editor
							[aufgabenTyp]="aufgabenTypen.VERMESSUNGSURKUNDE"
							[register]="register"
							data-test-id="verfuegung-vermessungsurkunde" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.SONSTIGE)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.SONSTIGE, $event.checked)"
					data-test-id="verfuegung-sonstige-checkbox">
					Sonstige
				</mat-checkbox>
				@if (formService.sonstigeGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-with-notiz-editor
							[aufgabenTyp]="aufgabenTypen.SONSTIGE"
							data-test-id="sonstige" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.RECHNUNGSSTELLUNG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.RECHNUNGSSTELLUNG, $event.checked)"
					data-test-id="verfuegung-rechnungsstellung-checkbox">
					Rechnungsstellung
					<span>fertigen</span>
				</mat-checkbox>
				@if (formService.rechnungsstellungGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-rechnungsstellung-editor
							data-test-id="verfuegung-rechnungsstellung" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.KOSTEN)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.KOSTEN, $event.checked)"
					data-test-id="kosten-checkbox">
					Kosten
				</mat-checkbox>
				@if (formService.kostenGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-with-notiz-editor
							[aufgabenTyp]="aufgabenTypen.KOSTEN"
							data-test-id="kosten" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.STATISTIK)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.STATISTIK, $event.checked)"
					data-test-id="statistik-checkbox">
					Statistik
				</mat-checkbox>
				@if (formService.statistikGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-with-notiz-editor
							[aufgabenTyp]="aufgabenTypen.STATISTIK"
							data-test-id="statistik" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.HEIMATHAFENVERLEGUNG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.HEIMATHAFENVERLEGUNG, $event.checked)"
					data-test-id="verfuegung-heimathafenverlegung-checkbox">
					Heimathafenverlegung
				</mat-checkbox>
				@if (formService.heimathafenverlegungGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-heimatverlegung-editor
							[aufgabenTyp]="aufgabenTypen.HEIMATHAFENVERLEGUNG"
							data-test-id="verfuegung-heimathafenverlegung" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.HEIMATORTVERLEGUNG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.HEIMATORTVERLEGUNG, $event.checked)"
					data-test-id="verfuegung-heimatortverlegung-checkbox">
					Heimatortverlegung
				</mat-checkbox>
				@if (formService.heimatortverlegungGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-heimatverlegung-editor
							[aufgabenTyp]="aufgabenTypen.HEIMATORTVERLEGUNG"
							data-test-id="verfuegung-heimatortverlegung" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.WIEDERVORLAGE)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.WIEDERVORLAGE, $event.checked)"
					data-test-id="verfuegung-wiedervorlage-checkbox">
					Wiedervorlagefrist
					<span>setzen</span>
				</mat-checkbox>
				@if (formService.wiedervorlageGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-wiedervorlage-editor
							[aufgabenTyp]="aufgabenTypen.WIEDERVORLAGE"
							data-test-id="verfuegung-wiedervorlage" />
					</div>
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.ABLAGE)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					(change)="toggleGroup(aufgabenTypen.ABLAGE, $event.checked)"
					data-test-id="verfuegung-ablage-checkbox">
					Ablage
				</mat-checkbox>
				@if (formService.ablageGroup.enabled) {
					<div class="editor">
						<mat-divider [vertical]="true" />
						<schir-int-client-aufgabe-with-notiz-editor
							[aufgabenTyp]="aufgabenTypen.ABLAGE"
							data-test-id="ablage" />
					</div>
				}
			}
			<mat-form-field appearance="outline">
				<mat-label>Notiz zur Verfügung</mat-label>
				<textarea
					matInput
					[formControl]="formService.controlVerfuegungNotiz"
					data-test-id="verfuegungs-notiz-input"></textarea>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions>
		<button
			mat-stroked-button
			(click)="onCancel()"
			type="button"
			class="focus-inwards-dark"
			data-test-id="abbrechen-button">
			Abbrechen
		</button>
		<button
			mat-flat-button
			color="primary"
			type="button"
			(click)="onSave()"
			[disabled]="!isValid()"
			class="icon-right focus-inwards-dark"
			data-test-id="speichern-button">
			Speichern
		</button>
	</mat-dialog-actions>
</form>
